












// @ is an alias to /src
import { getDefaultAloMedia } from '@/models/alo/AloMedia';
import { getImageUrl } from '@/utils/images';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'MainLoading',  
  props: {  
    loading:{
      type:Boolean,
      default:true
    }
  }
})
export default class MainLoading extends Vue {
  loading!:boolean

  
  get imageLoadingUrl(){
    return getImageUrl(getDefaultAloMedia(),80)
  }  
}
